module.exports = __webpack_public_path__ + "static/media/displeasure.afaa322f.svg";